import { __assign, __extends } from "tslib";
import PropTypes from 'prop-types';
import React, { createRef } from 'react';
import velocity from 'velocity-react/lib/velocity-animate-shim';
import { isNil } from 'lodash-es';
export default function controlScroll(Component) {
    var Scrollable = /** @class */ (function (_super) {
        __extends(Scrollable, _super);
        function Scrollable() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.scrollableRef = createRef();
            _this.getScrollPos = function () { return _this.scrollableRef.current.scrollTop; };
            _this.removeSmoothScrollHack = function () {
                _this.smoothScrollFix.parentNode.removeChild(_this.smoothScrollFix);
            };
            return _this;
        }
        Scrollable.prototype.componentDidMount = function () {
            this.setScrollPos();
        };
        Scrollable.prototype.componentDidUpdate = function () {
            this.setScrollPos();
        };
        Scrollable.prototype.setScrollPos = function () {
            if (!this.scrollableRef.current) {
                return;
            }
            var _a = this.props, scrollTop = _a.scrollTop, smoothScroll = _a.smoothScroll, onSetScrollEnd = _a.onSetScrollEnd;
            if (!isNil(scrollTop)) {
                if (smoothScroll) {
                    this.addSmoothScrollHack();
                    velocity(this.smoothScrollFix, 'scroll', {
                        duration: 1000,
                        easing: 'easeInOutQuad',
                        container: this.scrollableRef.current,
                        complete: this.removeSmoothScrollHack,
                    });
                }
                else {
                    var top_1;
                    var left = void 0;
                    if (scrollTop.top !== undefined) {
                        // TODO this should be handled outside of this component;
                        (top_1 = scrollTop.top, left = scrollTop.left);
                        this.scrollableRef.current.scrollTop = top_1;
                        this.scrollableRef.current.scrollLeft = left;
                    }
                    else {
                        this.scrollableRef.current.scrollTop = scrollTop;
                    }
                }
                if (onSetScrollEnd) {
                    onSetScrollEnd();
                }
            }
        };
        Scrollable.prototype.addSmoothScrollHack = function () {
            var smoothScrollFix = document.createElement('div');
            smoothScrollFix.setAttribute('style', "position: absolute; top: " + this.props.scrollTop + "px");
            this.smoothScrollFix = this.scrollableRef.current.appendChild(smoothScrollFix);
        };
        Scrollable.prototype.render = function () {
            return (React.createElement(Component, __assign({}, this.props, { getScrollPos: this.getScrollPos, withRef: this.scrollableRef })));
        };
        return Scrollable;
    }(React.Component));
    Scrollable.defaultProps = {
        smoothScroll: false,
    };
    Scrollable.propTypes = {
        scrollTop: PropTypes.number,
        smoothScroll: PropTypes.bool,
        onSetScrollEnd: PropTypes.func,
    };
    return Scrollable;
}
